import {computed, ComputedRef} from "vue";
import Translations from "@/models/Localization/Translations";
import {useStore} from "@/hooks/useStore";

/**
 * A composable function that provides reactive access to application translations
 * stored within the localization module of the state management store.
 *
 * @return {ComputedRef<Translations>} A reactive computed reference to the 'translations' object.
 */
export function useTranslations(): ComputedRef<Translations> {
  const store = useStore();

  const localizationState = computed(() => store.value.LocalizationModule);
  return computed(() => localizationState.value.translations);
}
